import { useState } from "react";

/**
 * Custom hook to manage pagination logic.
 * @param {Array} items - Array of items to paginate.
 * @param {number} itemsPerPage - Number of items per page.
 * @returns {Object} - Pagination controls and current page items.
 */
function usePagination(items, itemsPerPage) {
  const [currentPage, setCurrentPage] = useState(0);
  const totalPages = Math.ceil(items.length / itemsPerPage);

  const paginate = (direction) => {
    setCurrentPage((oldPage) => {
      const nextPage = oldPage + direction;
      if (nextPage < 0) return totalPages - 1;
      return nextPage % totalPages; // Loops back to the first page if at end
    });
  };

  const currentPageItems = items.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);
  return {
    currentPage,
    totalPages,
    paginate,
    currentPageItems,
  };
}

export default usePagination;
